import React from 'react';
import { View, Text } from 'react-native';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
export const Badge = ({ text, withBackground, textStyle, style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, withBackground ? styles.background : {}, style] },
        React.createElement(Text, { style: [styles.text, textStyle] }, text)));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {},
    background: {
        backgroundColor: color.primary.ghost,
        paddingVertical: size.B,
        paddingHorizontal: size.C,
        borderRadius: 9999
    },
    text: {
        fontWeight: '600',
        color: color.primary.solid,
        fontSize: 11,
        lineHeight: 13,
        letterSpacing: -0.01,
        textTransform: 'uppercase'
    }
}));
//# sourceMappingURL=index.js.map